import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import cl from 'classnames';

class FlagsSelect extends Component {
  state = {
    selected: this.props.selected,
    isOpen: false
  };

  handleDropdownToggle = () => {
    const { isOpen } = this.state;

    this.setState({
      isOpen: !isOpen
    });
  };

  handleItemSelection = (item) => {
    if (item.country !== this.state.selected.country) {
      const { onSelect } = this.props;

      this.setState({ selected: item }, () => {
        localStorage.setItem('i18n-locale', item.country);
        onSelect(item);
        window.location.reload();
      });
    }
  };

  render() {
    const { isOpen, selected } = this.state;
    const { options } = this.props;

    const selectedOption =
      options &&
      selected &&
      options.find((option) => option.country === selected.country);

    return (
      <Dropdown
        nav
        inNavbar
        isOpen={isOpen}
        toggle={this.handleDropdownToggle}
        className={cl('language', this.props.className)}
      >
        <DropdownToggle nav caret>
          <span>{selectedOption ? selectedOption.label : 'English'}</span>
        </DropdownToggle>
        <DropdownMenu right>
          {options.map(({ country, label }) => (
            <DropdownItem
              key={country}
              className="d-flex align-items-center"
              onClick={() => this.handleItemSelection({ country, label })}
            >
              <span>{label}</span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

FlagsSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      country: PropTypes.string,
      label: PropTypes.string
    }).isRequired
  ),
  selected: PropTypes.shape({
    country: PropTypes.string
  }).isRequired,
  onSelect: PropTypes.func,
  size: PropTypes.number,
  className: PropTypes.string
};

FlagsSelect.defaultProps = {
  options: [{}],
  onSelect: () => {},
  size: 20
};

const mapStateToProps = ({ i18n }) => ({
  selected: {
    country: i18n.locale
  }
});

export default connect(mapStateToProps)(FlagsSelect);
